<h2 mat-dialog-title class="text-lg font-bold mb-1">{{ (this.id == null ? 'Nuevo' : 'Editar')}} Registro</h2>
<mat-dialog-content class="modal-content">
  <form [formGroup]="form">
    <div class="grid grid-cols-1 gap-y-2 gap-x-4 mb-4">
      <app-form-section title="Información Básica" icon="info" iconColor="blue">
        <div class="grid grid-cols-2 gap-y-2 gap-x-4">
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Código</mat-label>
            <input matInput formControlName="code" [readonly]="this.id != null" [disabled]="this.id != null" required>
            <mat-error *ngIf="form.get('code')?.hasError('required')">Campo obligatorio</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="name" oninput="this.value = this.value.toUpperCase()" required>
            <mat-error *ngIf="form.get('name')?.hasError('required')">Campo obligatorio</mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Tipo</mat-label>
            <mat-select formControlName="documentDetailTypeId" required>
              @for (type of filteredDocumentTypeLineList; track type) {
              <mat-option [value]="type._id">
                {{ type.name }}
              </mat-option>
              }
            </mat-select>
            <mat-error *ngIf="form.get('documentDetailTypeId')?.hasError('required')">Campo
              obligatorio</mat-error>
          </mat-form-field>
          <mat-form-field appearance="fill" class="w-full">
            <mat-label>Compañía</mat-label>
            <mat-select formControlName="companyIds" multiple required>
              @for (company of companyFilterList; track company) {
              <mat-option [value]="company._id">
                {{ company.name }}
              </mat-option>
              }
            </mat-select>
            <mat-error *ngIf="form.get('companyIds')?.hasError('required')">Campo obligatorio</mat-error>
          </mat-form-field>
        </div>
      </app-form-section>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-4">
      @for (toggle of classToggles; track toggle.field) {
      @if(!toggle.classToggles){
      <app-toggle-option [formControlName]="toggle.field" [name]="toggle.field" [icon]="toggle.icon"
        [iconColor]="toggle.iconColor" [title]="toggle.title" [description]="toggle.description">
      </app-toggle-option>
      }
      }
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="p-4 flex justify-between">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!form.valid">Guardar</button>
</mat-dialog-actions>